import {convertJSONToDrawing} from '@application/helper/drawing/convert-json-to-drawing';
import {Drawing} from '@domain/production-schedule/drawing';
import {MachineSummary} from '@domain/production-schedule/machine-summary';
import {WeaveStructure} from '@domain/textile-data/weave-structure/weave-structure';
import {OverviewListProductConfiguration} from '@presentation/pages/texedit/product-configuration/overview/overview-list-product-configuration';
import {OverviewListColorSet} from '@presentation/pages/textile-data/color-set/overview/overview-list-color-set';
import {StringUtils} from '@vdw/angular-component-library';
import {SelectListProductConfigurationVersionHistory} from './select-list-product-configuration-version-history';
import {SelectListProductConfigurationWeaveQuality} from './select-list-product-configuration-weave-quality';

export class SelectListProductConfiguration extends OverviewListProductConfiguration {
  private readonly _weaveQuality: SelectListProductConfigurationWeaveQuality;
  private readonly _readyForProduction: boolean;
  private readonly _versionHistories: SelectListProductConfigurationVersionHistory[];

  public constructor(
    id: number,
    name: string,
    designs: Drawing[],
    description: string,
    dateModified: Date,
    machine: MachineSummary,
    helpWeaveStructures: WeaveStructure[],
    colorSet: OverviewListColorSet,
    weftColorSet: OverviewListColorSet,
    weaveQuality: SelectListProductConfigurationWeaveQuality,
    readyForProduction: boolean,
    versionHistories: SelectListProductConfigurationVersionHistory[]
  ) {
    super(id, name, null, designs, null, null, description, dateModified, machine, helpWeaveStructures, colorSet, weftColorSet);

    this._weaveQuality = weaveQuality;
    this._readyForProduction = readyForProduction;
    this._versionHistories = versionHistories;
  }

  public get weaveQuality(): SelectListProductConfigurationWeaveQuality {
    return this._weaveQuality;
  }

  public get readyForProduction(): boolean {
    return this._readyForProduction;
  }

  public get versionHistories(): SelectListProductConfigurationVersionHistory[] {
    return this._versionHistories;
  }

  public static fromJSON(productConfigurationJSON: any): SelectListProductConfiguration {
    const designs: Drawing[] = productConfigurationJSON?.drawings.map((design: Drawing) => {
      return convertJSONToDrawing(design);
    });

    return new SelectListProductConfiguration(
      productConfigurationJSON.id,
      productConfigurationJSON.name,
      designs,
      productConfigurationJSON.description,
      StringUtils.toDate(productConfigurationJSON.dateModified),
      MachineSummary.fromJSON(productConfigurationJSON.machine),
      productConfigurationJSON.weaveStructures.map((weaveStructure: WeaveStructure) => {
        return WeaveStructure.fromJSON(weaveStructure);
      }),
      productConfigurationJSON.colorSet === null ? null : OverviewListColorSet.fromJSON(productConfigurationJSON.colorSet),
      productConfigurationJSON.weftColorSet === null ? null : OverviewListColorSet.fromJSON(productConfigurationJSON.weftColorSet),
      SelectListProductConfigurationWeaveQuality.fromJSON(productConfigurationJSON.quality),
      productConfigurationJSON.readyForProduction,
      productConfigurationJSON.versionHistories.map(SelectListProductConfigurationVersionHistory.fromJSON)
    );
  }
}
